"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeError = void 0;
const runtimeSourceError_1 = require("../errors/runtimeSourceError");
const types_1 = require("../types");
class TypeError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(command, expected, received) {
        super(command);
        this.command = command;
        this.expected = expected;
        this.received = received;
        this.type = types_1.ErrorType.SYNTAX;
        this.severity = types_1.ErrorSeverity.ERROR;
    }
    explain() {
        return `Incompatible types: expected ${this.expected} but received ${this.received}`;
    }
    elaborate() {
        return `There is a type error. Try changing ${this.expected} to ${this.received} instead.`;
    }
}
exports.TypeError = TypeError;
//# sourceMappingURL=errors.js.map